// 点击
var $ = jQuery;
$(function(){

  recommendPagesClickTrack('.best-selling-con','HomePage_Top Sale');
  recommendPagesClickTrack('.flas-sale-con','HomePage_Flash Sale');
  recommendPagesClickTrack('.recommend-product-home-inner');
  publicFlashSaleClickTrack();
  publicBannerClickTrack( '.public-banner-com','.public-banner-con','.public-banner-item-img')
  publicMultiButtonClickTrack('.public-multi-button-com','.public-multi-button-con','.public-multi-button-item-but','.public-multi-button-text');

  // recommendPagesClickTrack()
  // 普通秒杀组件点击事件 

  // 第二版
    function publicFlashSaleClickTrack() {
      const containers = document.querySelectorAll('.flash-sale-wrapper');
    
      if (!containers.length) {
        console.warn('⚠️ 未找到 .flash-sale-wrapper 容器');
        return;
      }
    
      // console.log(`✅ 初始化 Flash Sale 点击打点，共找到 ${containers.length} 个组件`);
    
      containers.forEach((container, index) => {
        // 防止重复绑定
        if (container.__flash_click_bound__) return;
        container.__flash_click_bound__ = true;
    
        // 给每个组件加唯一标识，方便调试
        container.dataset.flashIndex = index;
    
        container.addEventListener('click', function (e) {
          const li = e.target.closest('li');
          if (!li || !container.contains(li)) return;
    
          const productBox = li.querySelector('.flash-sale-item__right');
          if (!productBox) {
            // console.warn(`⚠️ 组件 #${index} 未找到 .flash-sale-item__right 元素`, li);
            return;
          }
          // console.log('执行点击打印productBox',productBox);
          
          // 动态获取数据
          const item_id = productBox.dataset.productId ||  productBox.getAttribute('productid')  ||  'unknown_id';
          // console.log('执行点击打印item',item_id);
          const item_name = li.querySelector('.name')?.innerText?.trim() || 'unknown_name';
    
          // 区分不同页面来源
          let routeName = window.location.pathname; // e.g. "/pages/flash-kill-page"
          let el = '';
          let event_category = '';
          let event_action = 'productClick';
          let event_name = 'select_item';
          let item_list_name = '';
    
          const match = routeName.match(/^\/pages\/([^\/]+)/); // 捕获 /pages/ 后面的名称
          if (match && match[1]) {
            event_category = match[1];
            item_list_name = `${match[1]}_productList-activity`;
            el = `${match[1]}_productList-activity`;
          } 
    
          // ✅ 调试打印
          // console.log(`🖱️ [组件 #${index}] 点击商品打点：`, {
          //   item_id,
          //   item_name,
          //   item_list_name,
          //   event_category,
          //   routeName,
          // });
    
          // ✅ 发送埋点
          if (typeof gtag === 'function') {
            gtag('event', event_name, {
              items: [
                {
                  item_name,
                  item_id,
                  item_list_name,
                },
              ],
              event_category,
              event_action,
              event_label: el,
              send_to: 'G-FJD6WT8L84',
            });
            // console.log(`✅ [组件 #${index}] 成功推送点击打点: ${item_name}`);
          } else {
            console.warn('⚠️ gtag 未定义，未发送打点');
          }
        });
      });
    }

  // 智能推荐普通 page页 和首页
  function recommendPagesClickTrack(containerSelector, recommendListName) {
    // console.log('11111初始化_推荐点击', containerSelector);
  
    // 改为选中多个容器
    const containers = document.querySelectorAll(containerSelector);
  
    if (!containers.length) {
      console.warn('⚠️ 未找到容器：', containerSelector);
      return;
    }
  
    // console.log('✅ 初始化 首页智能 点击打点（支持多个容器）');
  
    // 遍历所有容器逐一绑定事件
    containers.forEach(container => {
      // 防止重复绑定
      if (container.__flash_click_bound__) return;
      container.__flash_click_bound__ = true;
  
      container.addEventListener('click', function (e) {
        if (e.target.closest('quick-view')) return;
  
        // console.log('2222初始化_推荐点击', recommendListName);
  
        let li = e.target.closest('li');
        // console.log('3333初始化_推荐点击', li);
  
        if (!li || !container.contains(li)) return;
        // console.log('4444初始化_推荐点击', li);
  
        const productBox = li.querySelector('.card-wrapper');
        if (!productBox) {
          console.warn('⚠️ 未找到产品元素 .card-wrapper', li);
          return;
        }
        // console.log('5555初始化_推荐点击', productBox);
  
  
        // ----------- 原本你的逻辑开始（完全保留） -----------------------
  
        const item_id =
          productBox.dataset.productId ||
          productBox.getAttribute('productid') ||
          'unknown_id';
  
        const item_name = li.querySelector('.ptit')?.innerText?.trim() || 'unknown_name';
        let item_list_name = '';
  
        const event_remark = li.classList.contains('gatg-li-default')
          ? 'product_default'
          : 'product_recommend';
  
        let routeName = window.location.pathname;
        let el = 'HomePage_Recommend';
        let event_category = 'HomePage';
        let dataIndex, imgSrcLastPart;
        let event_action = 'productClick';
        let event_name = 'select_item';
        let promotion_name = li.querySelector('img')?.alt || 'null';
  
        const match = routeName.match(/^\/pages\/([^\/]+)/);
  
        if (routeName !== '/') {
          if (match && match[1]) {
            event_category = match[1];
  
            if (productBox.classList.contains('card_recommend')) {
              dataIndex = li.dataset.index;
              const img = productBox.querySelector('img');
  
              if (img && img.src) {
                const parts = img.src.split('/');
                imgSrcLastPart = parts[parts.length - 1];
                el = match[1] + '_Recommend::activity';
                event_action = 'promoClick';
                event_name = 'select_promotion';
              }
  
              event_name_card_img(imgSrcLastPart, el, promotion_name, dataIndex, event_action, event_category, event_name);
  
            } else {
              el = match[1] + '_Recommend';
              item_list_name = match[1] + '_Recommend';
              event_name_product(event_name, item_name, item_id, item_list_name, event_category, event_action, el);
            }
          }
  
        } else {
          // console.log('初始化_首页');
  
          if (productBox.classList.contains('card_recommend')) {
            dataIndex = li.dataset.index;
            const img = productBox.querySelector('img');
  
            if (img && img.src) {
              const parts = img.src.split('/');
              imgSrcLastPart = parts[parts.length - 1];
              el = 'HomePage_Recommend::activity';
              event_action = 'promoClick';
              event_name = 'select_promotion';
            }
  
            event_name_card_img(imgSrcLastPart, el, promotion_name, dataIndex, event_action, event_category, event_name);
  
          } else {
            if (recommendListName) {
              el = recommendListName;
              item_list_name = recommendListName;
            } else {
              item_list_name = 'HomePage_Recommend';
            }
  
            event_name_product(event_name, item_name, item_id, item_list_name, event_category, event_action, el);
          }
        }
  
        // ---------- GA 事件（保持原样） -----------------
  
        function event_name_product(event_name, item_name, item_id, item_list_name, event_category, event_action, el) {
          gtag('event', event_name, {
            "items": [{
              item_name: item_name,
              item_id: item_id,
              item_list_name: item_list_name,
            }],
            "event_category": event_category,
            "event_action": event_action,
            "event_label": el,
            "event_remark": event_remark,
            "send_to": "G-FJD6WT8L84"
          });
        }
  
        function event_name_card_img(imgSrcLastPart, el, promotion_name, dataIndex, event_action, event_category, event_name) {
          gtag('event', event_name, {
            "items": [{
              item_name: imgSrcLastPart,
              item_id: el,
              promotion_id: el,
              promotion_name: promotion_name,
              creative_name: imgSrcLastPart,
              creative_slot: dataIndex
            }],
            "event_remark": event_remark,
            "event_category": event_category,
            "event_action": event_action,
            "event_label": el,
            "send_to": "G-FJD6WT8L84"
          });
        }
  
      });
    });
  }
   // 位于除顶部banner外 其他位置图片或轮播图点击 
   function publicBannerClickTrack(containerSelector, itemSelector, item) {
    // console.log('🔥 banner组件埋点初始化', containerSelector);
  
    // 支持多个容器
    const containers = document.querySelectorAll(containerSelector);
    if (!containers.length) return;
  
    containers.forEach((container, index) => {
      
      // 防重复绑定
      if (container.__banner_click_bound__) return;
      container.__banner_click_bound__ = true;
  
      container.dataset.bannerIndex = index;
  
      // 事件委托
      container.addEventListener('click', function (e) {
  
        const li = e.target.closest(itemSelector);
        if (!li || !container.contains(li)) return;
  
        const productBox = e.target.closest(item);
        if (!productBox) {
          console.warn(`⚠️ [banner #${index}] 未找到 item 元素：${item}`, li);
          return;
        }
  
        // ====== 动态数据 ======
        let routeName = window.location.pathname;
        let event_category = "";
        let item_list_name = "";
        let event_action = "promoClick";
        let event_name = "select_promotion";
        
        let el = "";
        let creative_name = "";
        let creative_slot = productBox.dataset.indexId || "";
  
        const match = routeName.match(/^\/pages\/([^\/]+)/);
  
        if (match && match[1]) {
          event_category = match[1];
          item_list_name = `${match[1]}_productList-activity`;
          el = `${match[1]}_pic-category`;
        } else {
          // 主页或其他无法解析路径的页面
          event_category = "HomePage";
          item_list_name = "HomePage_productList-activity";
          el = "HomePage_pic-category";
        }
  
        // 获取图片名称：source > img
        const source = productBox.querySelector('source');
        if (source?.srcset) {
          creative_name = source.srcset.split('/').pop();
        } else {
          // const img = productBox.querySelector('img');
          const img = productBox.matches('img')
                      ? productBox
                      : productBox.querySelector('img');

          creative_name = img?.src?.split('/').pop() || "unknown_img";
        }
  
        // ======= 调试输出 =======
        // console.log("🟦 banner CLICK 埋点:", {
        //   event_category,
        //   el,
        //   creative_name,
        //   creative_slot,
        //   event_action,
        //   event_name
        // });
  
        // ======= 发送 GA4 埋点 =======
        if (typeof gtag === "function") {
          gtag('event', event_name, {
            items: [{
              item_name: event_category,
              item_id: el,
              creative_slot,
              promotion_id: el,
              promotion_name: event_category,
              creative_name,
            }],
            event_category,
            event_action,
            event_label: el,
            send_to: "G-FJD6WT8L84"
          });
        } else {
          console.warn("⚠️ gtag 未定义，无法发送埋点");
        }
  
      }); // end click
  
    }); // end containers.forEach
  }

  // 多组按钮
  function publicMultiButtonClickTrack(containerSelector,itemSelector,item,itemText ) {
    // console.log('多组按钮组件埋点方法');
    
    const containers = document.querySelectorAll(containerSelector);
  
    if (!containers.length) {
      console.warn('⚠️ 未找到 .flash-sale-wrapper 容器');
      return;
    }
  
    // console.log(`✅ 初始化 Flash Sale 点击打点，共找到 ${containers.length} 个组件`);
  
    containers.forEach((container, index) => {
      // 防止重复绑定
      if (container.__flash_click_bound__) return;
      container.__flash_click_bound__ = true;
  
      // 给每个组件加唯一标识，方便调试
      container.dataset.flashIndex = index;
  
      container.addEventListener('click', function (e) {
        const li = e.target.closest(itemSelector);
        // console.log("点击触发普通组件banner", li);
        
        if (!li || !container.contains(li)) return;
        // console.log("点击事件触发普通组件banner326", li);
  
        // const productBox = li.querySelector(item);
        const productBox = e.target.closest(item);
        // console.log('175行检车数据',productBox);
        if (!productBox) {
          // console.log('177行检车数据');
          // console.warn(`⚠️ 组件 #${index} 未找到 .flash-sale-item__right 元素`, li);
          return;
        }
        // console.log('181行检车数据');
        // 动态获取数据
        // const item_id = productBox.dataset.productId || 'unknown_id';

        // const item_name = li.querySelector('.title')?.innerText?.trim() || 'unknown_name';
        // console.log('183行检车数据 ');
  
        // 区分不同页面来源
        let routeName = window.location.pathname; // e.g. "/pages/flash-kill-page"
        let el = '';
        let event_category = '';
        let event_action = 'promoClick';
        let event_name = 'select_promotion';
        let creative_name = '';
        let creative_slot =  productBox.dataset.indexId;
        let title = productBox.querySelector(itemText);
        let promotion_name = title ? title.innerText.trim() : '';
  
        const match = routeName.match(/^\/pages\/([^\/]+)/); // 捕获 /pages/ 后面的名称
        if (match && match[1]) {
          event_category = match[1];
          item_list_name = `${match[1]}_productList-activity`;
          el = `${match[1]}_promotion-categories`;
        } 
        // === 卡片曝光 ===
        if (productBox) {
          // console.log('productBox存在');
          
          const source = productBox.querySelector('source');
          const img = productBox.querySelector('img');



          // if (img?.src) creative_slot = img.src.split('/').pop();
          // img && img.srcset
          if (source) {
            // console.log('获取source标签');
            creative_name = source.srcset.split('/').pop();
          }else if(img){
            // console.log('获取img标签');
            creative_name = img.src.split('/').pop();
          }else{
            creative_name = promotion_name;
          }
          // el = `${event_category}_Recommend::activity`;
          // event_action = 'promoView';
          // event_name = 'view_promotion图片';
        }else{
          // console.log('productBox不存在');
        }
  
        // ✅ 调试打印
        // console.log('👀除顶部banner 曝光推送:', {
            
        //     event_category,
        //     creative_slot,
        //     creative_name,
        //     promotion_name,
        //     el,
        //     event_action,
        //   });
  
        // ✅ 发送埋点
        if (typeof gtag === 'function') {
          gtag('event', event_name, {
            items: [{
              item_name:promotion_name,
              item_id: el,
              creative_slot,
              promotion_id:el,
              promotion_name:promotion_name,
              creative_name,
            }],
            event_category,
            event_action,
            event_label: el,
            send_to: "G-FJD6WT8L84"
          });
          // console.log(`✅ [组件 #${index}] 成功推送点击打点: ${item_name}`);
        } else {
          console.warn('⚠️ gtag 未定义，未发送打点');
        }
      });
    });
  }
  

// console.log("点击底部加载");

})


// 曝光
var $ = jQuery;
$(function () {
  // console.log("曝光加载");
  


    // 秒杀通用曝光
    // 五
      function publicFlashSaleViewPages(containerSelector) {
        console.log('✅ 初始化秒杀曝光监听');
      
        const containers = document.querySelectorAll(containerSelector);
        if (!containers.length) {
          console.warn(`❌ 未找到容器: ${containerSelector}`);
          return;
        }
      
        // 每个容器有独立 Set
        const containerExposeMap = new WeakMap();
      
        // === IntersectionObserver（只触发一次）===
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
      
            const li = entry.target;
            const container = li.__belongsContainer;  // ⭐ 使用绑定的容器，而不是 closest()
            if (!container) return;
      
            let exposedIds = containerExposeMap.get(container);
            if (!exposedIds) {
              exposedIds = new Set();
              containerExposeMap.set(container, exposedIds);
            }
      
            const productBox = li.querySelector('[data-product-id]') || li.querySelector('[productid]');
            if (!productBox) return;
      
            const item_id = productBox.dataset.productId || productBox.getAttribute('productid') || 'unknown_id';
            const item_name = li.querySelector('.name')?.innerText?.trim() || '';
      
            if (exposedIds.has(item_id)) {
              observer.unobserve(li);
              return;
            }
      
            exposedIds.add(item_id);
      
            // 页面信息
            const routeName = window.location.pathname;
            let event_category = '';
            let item_list_name = '_productList-activity';
            let el = '_productList-activity';
      
            const match = routeName.match(/^\/pages\/([^\/]+)/);
            if (match && match[1]) {
              event_category = match[1];
              item_list_name = `${match[1]}_productList-activity`;
              el = `${match[1]}_productList-activity`;
            }
      
            // === GA 打点 ===
            if (typeof gtag === 'function') {
              gtag('event', 'view_item_list', {
                items: [{ item_name, item_id, item_list_name }],
                event_category,
                event_action: 'productView',
                event_label: el,
                send_to: "G-FJD6WT8L84"
              });
            } else {
              console.warn('⚠️ gtag 未定义，曝光未发送');
            }
      
            observer.unobserve(li); // 曝光一次即可
          });
        }, {
          threshold: 0.3
        });
      
        // === 绑定 li（关键：绑定容器）===
        function observeItems(container) {
          const items = container.querySelectorAll('ul li');
      
          let exposedIds = containerExposeMap.get(container);
          if (!exposedIds) {
            exposedIds = new Set();
            containerExposeMap.set(container, exposedIds);
          }
      
          items.forEach(li => {
            const productBox = li.querySelector('[data-product-id]') || li.querySelector('[productid]');
            if (!productBox) return;
      
            const item_id = productBox.dataset.productId || productBox.getAttribute('productid');
            if (exposedIds.has(item_id)) return;
      
            // ⭐⭐ 在元素上附加所属容器，避免 closest() 误判
            li.__belongsContainer = container;
      
            observer.observe(li);
          });
        }
      
        // 初始化
        containers.forEach(container => observeItems(container));
      
        // 动态内容监听
        containers.forEach(container => {
          const mutationObserver = new MutationObserver(() => observeItems(container));
          mutationObserver.observe(container, { childList: true, subtree: true });
        });
      }

    // 页面加载后初始化
    // $(function() {
    //   // 智能推荐曝光
    //   trackExposure('.recommend-product-home-inner');
    //   // 限时抢购曝光
    //   publicFlashSaleViewPages('.flash-sale-wrapper');
    // });



  // 智能推荐通用曝光
    function trackExposure(containerSelector, itemSelector) {
      console.log('✅ 初始化 智能推荐组件曝光监听');
    
      const containers = document.querySelectorAll(containerSelector);
      if (!containers.length) {
        console.warn(`❌ 未找到容器: ${containerSelector}`);
        return;
      }
      // console.log('执行710');
    
      // 只按 DOM 盒子去重（每个 .Grid__Cell 只曝光一次）
      window.__EXPOSED_BOXES__ = window.__EXPOSED_BOXES__ || new WeakSet();
      const exposedBoxes = window.__EXPOSED_BOXES__;
      // console.log('执行715');
      const observer = new IntersectionObserver((entries) => {
        // console.log('执行717');
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
    
          const li = entry.target;
    
          // === DOM 去重 ===
          if (exposedBoxes.has(li)) {
            observer.unobserve(li);
            return;
          }
          exposedBoxes.add(li);
          // console.log('执行729');
          // 是否为卡片
          // const productBox = li.querySelector('[productid]') || li.querySelector('[data-product-id]');
          // console.log('打印productBox',productBox);
          
          // const isCard = !productBox;
          // console.log('打印isCard',isCard);
          const productBox = li.querySelector('[productid]') || li.querySelector('[data-product-id]');
          let p_id = productBox?.getAttribute('data-product-id') || productBox?.dataset.productId || '';
          p_id = p_id.trim();
          const isCard = !p_id; // ← 商品 id 为空也算卡片
          // console.log('打印p_id',p_id);
          // console.log('打印productBox',productBox);
          // console.log('打印isCard',isCard);
          console.log('li:',li);
          
          // === 事件 remark 判断 ===
          const event_remark = li.classList.contains('gatg-li-default')
            ? 'product_default'
            : 'product_recommend';
          // 曝光之前判断下产品 页面 + 类型 
          const routeName = window.location.pathname;
          let event_category = routeName === '/'
            ? 'HomePage'
            : (routeName.match(/^\/pages\/([^\/]+)/)?.[1] || 'Unknown_Page');
    
          let item_list_name = `${event_category}_Recommend`;
          let el = item_list_name;
          let item_name = ''
          let event_action = 'productView';
          let event_name = 'view_item_list';
          let creative_slot = 'null';
          let creative_name = 'null'
          let item_id = isCard
          ? `card_${li.dataset.index || creative_slot || 'unknown'}`
          : (productBox?.getAttribute('productid') ??
             productBox?.dataset.productId ??
             null);
             console.log('打印路由',routeName);
             
             if (routeName !== '/') {
              // console.log('执行非首页曝光');
              // === 卡片曝光 ===
              if (isCard) {
                // console.log('走卡片曝光762');
                
                const img = li.querySelector('.card_recommend img');
                // console.log("打印卡片img标签",img);
                
                // const video = li.querySelector('.ProductItem_video_img');
                const video = li.querySelector('.card_recommend video') ? li.querySelector('.card_recommend video') : false;
                const sourceSrc = li.querySelector('source');
                const imgSrc = li.querySelector('img');
                creative_name =
                (sourceSrc?.srcset && sourceSrc.srcset.split('/').pop()) ||
                (imgSrc?.src && imgSrc.src.split('/').pop()) ||
                null;

                if (img) {

                  // if (img?.src) creative_slot = img.src.split('/').pop();
          
                  el = `${event_category}_Recommend::activity`;
                  event_action = 'promoView';
                  event_name = 'view_promotion';
                  item_name = event_category;
                }else if (video) {
                  el = `${event_category}_Recommend::video`;
                  event_action = 'promoView';
                  event_name = 'view_promotion';
                  item_name = event_category;
                }
                // item_name = event_category;
                item_id = el;

                // 走卡片单独推送
                if (typeof gtag === 'function') {
                  gtag('event', event_name, {
                    items: [{
                      item_name,
                      item_id,
                      promotion_id:el,
                      promotion_name:event_category,
                      creative_name,
                      creative_slot
                    }],
                    event_category,
                    event_action,
                    event_label: el,
                    event_remark, // ← ★ 新增字段
                    send_to: "G-FJD6WT8L84"
                  });
                }

              }else{
                // console.log('走产品曝光');
                // console.log('打印底部inner的li',li);
                // console.log('打印底部inner的productBox',productBox);
                  // === 取商品名 ===
                  setTimeout(() => {
                      const item_name = productBox.querySelector('.ptit')?.innerText?.trim() || 'null';
                      // console.log("最终 item_name:", item_name);

                      // 走产品推送
                      if (typeof gtag === 'function') {
                        gtag('event', event_name, {
                          items: [{
                            item_name,
                            item_id,
                            item_list_name
                          }],
                          event_category,
                          event_action,
                          event_label: el,
                          event_remark, // ← ★ 新增字段
                          send_to: "G-FJD6WT8L84"
                        });
                      }

                    }, 100);
                  
                
              }
             }else{
             
              // console.log('执行首页曝光',containerSelector); // .best-selling-con     .flas-sale-con
              
              if (isCard) {
                // console.log('走卡片曝光762');
               
                const img = li.querySelector('.card_recommend img');
                // console.log("打印卡片img标签",img);
                
                // const video = li.querySelector('.ProductItem_video_img');
                const video = li.querySelector('.card_recommend video') ? li.querySelector('.card_recommend video') : false;
                const sourceSrc = li.querySelector('source');
                const imgSrc = li.querySelector('img');
                creative_name =
                (sourceSrc?.srcset && sourceSrc.srcset.split('/').pop()) ||
                (imgSrc?.src && imgSrc.src.split('/').pop()) ||
                null;

                if (img) {
                  if(containerSelector == '.recommend-product-home-inner'){
                    // console.log('执行flash曝光');
                    item_list_name = 'HomePage_Recommend::activity';
                    el = item_list_name;
                  }

                  // if (img?.src) creative_slot = img.src.split('/').pop();
          
                  el = `${event_category}_Recommend::activity`;
                  event_action = 'promoView';
                  event_name = 'view_promotion';
                  item_name = event_category;
                }else if (video) {
                  if(containerSelector == '.recommend-product-home-inner'){
                    // console.log('执行flash曝光');
                    item_list_name = 'HomePage_Recommend::video';
                    el = item_list_name;
                  }
                  el = `${event_category}_Recommend::video`;
                  event_action = 'promoView';
                  event_name = 'view_promotion';
                  item_name = event_category;
                }
                // item_name = event_category;
                item_id = el;

                // 走卡片单独推送
                if (typeof gtag === 'function') {
                  gtag('event', event_name, {
                    items: [{
                      item_name,
                      item_id,
                      promotion_id:el,
                      promotion_name:event_category,
                      creative_name,
                      creative_slot
                    }],
                    event_category,
                    event_action,
                    event_label: el,
                    event_remark, // ← ★ 新增字段
                    send_to: "G-FJD6WT8L84"
                  });
                }

              }else{
                // console.log('走产品曝光');
                // console.log('打印底部inner的li',li);
                // console.log('打印底部inner的productBox',productBox);

                if (containerSelector == '.best-selling-con') {
                  // console.log('执行best曝光');
                  item_list_name = 'HomePage_Top Sale';
                  el = item_list_name;
                }else if(containerSelector == '.flas-sale-con'){
                  // console.log('执行flash曝光');
                  item_list_name = 'HomePage_Flash Sale';
                  el = item_list_name;
                }else if(containerSelector == '.recommend-product-home-inner'){
                  // console.log('执行flash曝光');
                  item_list_name = 'HomePage_Recommend';
                  el = item_list_name;
                }


                  // === 取商品名 ===
                  setTimeout(() => {
                      const item_name = productBox.querySelector('.ptit')?.innerText?.trim() || 'null';
                      // console.log("最终 item_name:", item_name);

                      // 走产品推送
                      if (typeof gtag === 'function') {
                        gtag('event', event_name, {
                          items: [{
                            item_name,
                            item_id,
                            item_list_name
                          }],
                          event_category,
                          event_action,
                          event_label: el,
                          event_remark, // ← ★ 新增字段
                          send_to: "G-FJD6WT8L84"
                        });
                      }

                    }, 100);
                  
                
              }
             }
          


    
          
    
          // console.log('👀 曝光推送:', {
            // : isCard
            // ? `card_${li.dataset.index || creative_slot || 'unknown'}`
            // : (productBox?.getAttribute('productid') || productBox?.dataset.productId || 'unknown')
          //   item_name,
          //   isCard,
          //   event_category,
          //   event_name,
          //   event_action,
          //   event_remark
          // });
    
          
    
          observer.unobserve(li);
        });
      }, { threshold: 0.3 });
    
      // === 绑定 observer 到每个 Grid__Cell ===
      function observeItems(container) {
        const items = container.querySelectorAll(itemSelector);
        items.forEach(li => {
          if (!exposedBoxes.has(li)) observer.observe(li);
        });
      }
    
      containers.forEach(container => observeItems(container));
    
      // 动态内容监听
      containers.forEach(container => {
        const mutationObserver = new MutationObserver(() => observeItems(container));
        mutationObserver.observe(container, { childList: true, subtree: true });
      });
    
      // 滚动检测
      window.addEventListener('scroll', () => {
        containers.forEach(container => observeItems(container));
      });
    }

    // 位于除顶部banner外 其他位置图片或轮播图
    function publicBannerViewPages(containerSelector, itemSelector) {
      console.log('✅ 初始化 智能推荐组件曝光监听banner ');
    
      const containers = document.querySelectorAll(containerSelector);
      if (!containers.length) {
        console.warn(`❌ 未找到容器: ${containerSelector}`);
        return;
      }
    
      // 只按 DOM 盒子去重（每个 .Grid__Cell 只曝光一次）
      window.__EXPOSED_BOXES__ = window.__EXPOSED_BOXES__ || new WeakSet();
      const exposedBoxes = window.__EXPOSED_BOXES__;
    
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
    
          const li = entry.target;
          // console.log('打印li的内容',li);
          
    
          // === DOM 去重 ===
          if (exposedBoxes.has(li)) {
            observer.unobserve(li);
            return;
          }
          exposedBoxes.add(li);
    
          // 是否为卡片
          // li 本身有 data-index-id
          // if (li.hasAttribute('data-index-id')) {
          //   productBox = li;
          // } else {
          //   // 否则找内部的 productid
          //   productBox = li.querySelector('[productid]');
          // }
          const productBox = li.hasAttribute('data-index-id') ?  li : li.querySelector('[productid]')

          // const productBox = li.querySelector('[productid]') || li.querySelector('[data-index-id]');
          // const isCard = !productBox;
          // console.log('打印productBox',productBox);
          
          // === 事件 remark 判断 ===
          // const event_remark = li.classList.contains('gatg-li-default')
          //   ? 'product_default'
          //   : 'product_recommend';
    
          // === 取商品名 ===
          // const item_name = li.querySelector('.ptit')?.innerText?.trim() || 'unknown_name';
          
    
          const routeName = window.location.pathname;
          let event_category = routeName === '/'
            ? 'HomePage'
            : (routeName.match(/^\/pages\/([^\/]+)/)?.[1] || 'Unknown_Page');
    
          let item_id = 'null';
          let el = `${event_category}_pic-category`;
    
          let event_action = 'promoView';
          let event_name = 'view_promotion';
          let creative_slot =  productBox.dataset.indexId;
          let creative_name = '';
          let item_name =`${event_category}`;
          let promotion_name = `${event_category}`;
    
          // === 卡片曝光 ===
          if (productBox) {
            // console.log('productBox存在');
            
            const source = productBox.querySelector('source');



            // if (img?.src) creative_slot = img.src.split('/').pop();
            // img && img.srcset
            if (source) {
              // console.log('获取source标签');
              creative_name = source.srcset.split('/').pop();
            }else{
              // console.log('获取img标签');
              const img = productBox.matches('img')
                          ? productBox
                          : productBox.querySelector('img');

              creative_name = img.src.split('/').pop();
            }
            // el = `${event_category}_Recommend::activity`;
            // event_action = 'promoView';
            // event_name = 'view_promotion图片';
          }else{
            // console.log('productBox不存在');
          }
    
          // console.log('👀除顶部banner 曝光推送:', {
          //   item_name,
          //   item_id ,
          //   creative_slot,
          //   promotion_name,
          //   creative_name,
          //   el,
          //   event_action,
          // });
    
          if (typeof gtag === 'function') {
            gtag('event', event_name, {
              items: [{
                item_name,
                item_id: el,
                creative_slot,
                promotion_id:el,
                promotion_name,
                creative_name,
              }],
              event_category,
              event_action,
              event_label: el,
              send_to: "G-FJD6WT8L84"
            });
          }
    
          observer.unobserve(li);
        });
      }, { threshold: 0.3 });
    
      // === 绑定 observer 到每个 Grid__Cell ===
      function observeItems(container) {
        const items = container.querySelectorAll(itemSelector);
        items.forEach(li => {
          if (!exposedBoxes.has(li)) observer.observe(li);
        });
      }
    
      containers.forEach(container => observeItems(container));
    
      // 动态内容监听
      containers.forEach(container => {
        const mutationObserver = new MutationObserver(() => observeItems(container));
        mutationObserver.observe(container, { childList: true, subtree: true });
      });
    
      // 滚动检测
      window.addEventListener('scroll', () => {
        containers.forEach(container => observeItems(container));
      });
    }
    // 多组按钮
    function publicMultiButtonViewPages(containerSelector, itemSelector,itemSelectText) {
      console.log('✅ 初始化 智能推荐组件曝光监听多组按钮圆形菜单 ');
    
      const containers = document.querySelectorAll(containerSelector);
      // console.log('圆形菜单997containers',containers);
      
      if (!containers.length) {
        console.warn(`❌ 未找到容器: ${containerSelector}`);
        return;
      }
      // console.log('圆形菜单1003');
      // 只按 DOM 盒子去重（每个 .Grid__Cell 只曝光一次）
      window.__EXPOSED_BOXES__ = window.__EXPOSED_BOXES__ || new WeakSet();
      const exposedBoxes = window.__EXPOSED_BOXES__;
    
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
    
          const li = entry.target;
          // console.log('打印li的内容圆形菜单',li);
          
    
          // === DOM 去重 ===
          if (exposedBoxes.has(li)) {
            observer.unobserve(li);
            return;
          }
          exposedBoxes.add(li);
    
          // 是否为卡片
          // li 本身有 data-index-id
          // if (li.hasAttribute('data-index-id')) {
          //   productBox = li;
          // } else {
          //   // 否则找内部的 productid
          //   productBox = li.querySelector('[productid]');
          // }
          const productBox = li.hasAttribute('data-index-id') ?  li : li.querySelector('[productid]')

          // const productBox = li.querySelector('[productid]') || li.querySelector('[data-index-id]');
          // const isCard = !productBox;
          // console.log('打印productBox圆形菜单',productBox);
          
          // === 事件 remark 判断 ===
          // const event_remark = li.classList.contains('gatg-li-default')
          //   ? 'product_default'
          //   : 'product_recommend';
    
          // === 取商品名 ===
          // const item_name = li.querySelector('.ptit')?.innerText?.trim() || 'unknown_name';
          
    
          const routeName = window.location.pathname;
          let event_category = routeName === '/'
            ? 'HomePage'
            : (routeName.match(/^\/pages\/([^\/]+)/)?.[1] || 'Unknown_Page');
    
          let item_id = 'null';
          let el = `${event_category}_promotion-categories`;
    
          let event_action = 'promoView';
          let event_name = 'view_promotion';
          let creative_slot =  productBox.dataset.indexId;
          let creative_name = '';
          let item_name =`${event_category}`;
          // let promotion_name =productBox.querySelector(itemSelectText).innerText().trim() ;
          let title = productBox.querySelector(itemSelectText);
          let promotion_name = title ? title.innerText.trim() : '';
    
          // === 卡片曝光 ===
          if (productBox) {
            // console.log('productBox存在圆形菜单');
            
            const source = productBox.querySelector('source');
            const img = productBox.querySelector('img');



            // if (img?.src) creative_slot = img.src.split('/').pop();
            // img && img.srcset
            if (source) {
              // console.log('获取source标签圆形菜单');
              creative_name = source.srcset.split('/').pop();
            }else if(img) {
              // console.log('获取img标签圆形菜单');
              
              creative_name = img.src.split('/').pop();
            }else{
              creative_name = promotion_name;
            }
            // el = `${event_category}_Recommend::activity`;
            // event_action = 'promoView';
            // event_name = 'view_promotion图片';
          }else{
            // console.log('productBox不存在圆形菜单');
          }
    
          // console.log('👀圆形菜单 曝光推送:', {
          //   item_name,
          //   item_id ,
          //   creative_slot,
          //   promotion_name,
          //   creative_name,
          //   el,
          //   event_action,
          // });
    
          if (typeof gtag === 'function') {
            gtag('event', event_name, {
              items: [{
                item_name:promotion_name,
                item_id: el,
                promotion_id: el,
                creative_slot,
                promotion_name,
                creative_name,
              }],
              event_category,
              event_action,
              event_label: el,
              send_to: "G-FJD6WT8L84"
            });
          }
    
          observer.unobserve(li);
        });
      }, { threshold: 0.3 });
    
      // === 绑定 observer 到每个 Grid__Cell ===
      function observeItems(container) {
        const items = container.querySelectorAll(itemSelector);
        items.forEach(li => {
          if (!exposedBoxes.has(li)) observer.observe(li);
        });
      }
    
      containers.forEach(container => observeItems(container));
    
      // 动态内容监听
      containers.forEach(container => {
        const mutationObserver = new MutationObserver(() => observeItems(container));
        mutationObserver.observe(container, { childList: true, subtree: true });
      });
    
      // 滚动检测
      window.addEventListener('scroll', () => {
        containers.forEach(container => observeItems(container));
      });
    }

    // 页面加载后初始化不同模块
    $(function() {
      // best selling 曝光事件 后续需要单独拎出来 
      
      trackExposure('.best-selling-con', '.product-grid .grid__item');
      trackExposure('.flas-sale-con', '.product-grid .grid__item');
      // 首页智能推荐 曝光事件
      // trackExposure('.recommend-product-home-inner' );
      trackExposure('.recommend-product-home-inner', '.product-grid .grid__item');


      // trackExposure('.flash-sale-con', 'Homepage_Flash_Sale');
      publicFlashSaleViewPages('.flash-sale-wrapper');
      // 位于除顶部banner外 其他位置图片或轮播图
      publicBannerViewPages('.public-banner-con','.public-banner-item-img');
      // 多组按钮
      publicMultiButtonViewPages('.public-multi-button-con','.public-multi-button-item-but','.public-multi-button-text');
      
    });




});
